module.exports = __webpack_public_path__ + "static/media/New_customer_manually.daf02225.png";